import React from "react";

// The navy page ground with soft copper / blue glows. Purely decorative; the
// parent must be `relative isolate` (so -z-10 stays behind its content but
// above its background) and clip overflow.
const SiteBackdrop = () => (
  <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10">
    <div className="absolute inset-0 bg-gradient-to-b from-header via-background to-header" />
    <div className="absolute -top-48 -right-40 h-[34rem] w-[34rem] rounded-full bg-mainButton/20 blur-3xl" />
    <div className="absolute top-[30%] -left-48 h-[30rem] w-[30rem] rounded-full bg-behindButton/25 blur-3xl" />
  </div>
);

export default SiteBackdrop;
